var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',_vm._b({attrs:{"src":_vm.source.src,"srcset":_vm.source.srcset || null,"sizes":_vm.source.srcset ? _vm.sizes : null},on:{"error":_vm.fallbackToOriginal}},'img',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }